import { useLocalStorage } from '@mantine/hooks';

import type { ChatSession } from '#components/chat/types';

export const useChatSessionHistory = () =>
  useLocalStorage<Record<string, ChatSession>>({
    key: 'chat-session-history',
    getInitialValueInEffect: false,
    defaultValue: {},
  });
